import React from 'react';
import { Menu } from 'antd';
import MaterialIcon from './../../components/MaterialIcon';
import Button from '@material-ui/core/Button';
//import Config from '../../constants/appConfig';

const SubMenu = Menu.SubMenu;

class SidMenu extends React.Component {
    componentDidMount() {
        document.getElementById("loading").classList.add('load');
    }

    handleClick = (url, hide, link) => {
        this.props.handleClick(url, hide, link);
    }

    render() {
        const { hide, link, res, size, profile } = this.props;
        return (
            <div className={"menu " + size}>
                {profile &&
                    <Menu
                        className=".nav-menu "
                        mode="inline"
                        theme="dark"
                    >
                        <Menu.Item key="0.25">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/dashboard', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="dashboard" className="iconS icon-pos iconMenu" />
                                <span>{res.DASHBOARD}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.24">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/painel-qualidade', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="assessment" className="iconS icon-pos iconMenu" />
                                <span>{res.DASHBOARD_QUALIDADE}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.1">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/ciclo', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="trending_up" className="iconS icon-pos iconMenu" />
                                <span>{res.CICLO_OPERACAO}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.1.1">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/agenda', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="margin" className="iconS icon-pos iconMenu" />
                                <span>{res.AGENDA}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.2">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/ordem-servico/list', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="description" className="iconS icon-pos iconMenu" />
                                <span>{res.ORDEM_SERVICO}</span>
                            </Button>
                        </Menu.Item>
                        {/* <Menu.Item key="0.2">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/preoperacao/edit', hide, link) }} disabled={!profile.includes(10)}>
                                <MaterialIcon icon="description" className="iconS icon-pos iconMenu" />
                                <span>{res.PRE_OPERACAO}</span>
                            </Button>
                        </Menu.Item> */}
                        <Menu.Item key="0.3">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/draw', hide, link) }} disabled={!profile.includes(3)}>
                                <svg xmlns="http://www.w3.org/2000/svg" style={{ paddingLeft: '.4rem' }} width="1.8rem" height="1.8rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="0 -100 800 800">
                                    <path d="M460.8,311.95V251.3c29.7-10.62,51.2-38.78,51.2-72.1c0-42.32-34.48-76.8-76.8-76.8c-21.12,0-40.28,8.57-54.18,22.42
                                                L280.8,84.75c0.25-2.65,0.8-5.22,0.8-7.95c0-42.33-34.48-76.8-76.8-76.8C162.45,0,128,34.47,128,76.8
                                                c0,19.52,7.55,37.15,19.57,50.72l-42.85,57.1c-8.67-3.4-18.05-5.43-27.92-5.43C34.45,179.2,0,213.68,0,256
                                                c0,42.35,34.45,76.8,76.8,76.8c4.05,0,8-0.57,11.9-1.2l49.53,66.02C131.88,408.77,128,421.48,128,435.2
                                                c0,42.35,34.45,76.8,76.8,76.8c34.75,0,63.85-23.38,73.28-55.1l101.42-20.27c14.02,14.8,33.75,24.17,55.7,24.17
                                                c42.32,0,76.8-34.45,76.8-76.8C512,350.67,490.5,322.55,460.8,311.95z M435.2,153.6c14.12,0,25.6,11.5,25.6,25.6
                                                c0,14.1-11.47,25.6-25.6,25.6c-14.15,0-25.6-11.5-25.6-25.6C409.6,165.1,421.05,153.6,435.2,153.6z M204.8,51.2
                                                c14.12,0,25.6,11.5,25.6,25.6s-11.47,25.6-25.6,25.6c-14.15,0-25.6-11.5-25.6-25.6S190.65,51.2,204.8,51.2z M51.2,256
                                                c0-14.1,11.45-25.6,25.6-25.6c14.12,0,25.6,11.5,25.6,25.6s-11.47,25.6-25.6,25.6C62.65,281.6,51.2,270.1,51.2,256z M204.8,460.8
                                                c-14.15,0-25.6-11.47-25.6-25.6s11.45-25.6,25.6-25.6c14.12,0,25.6,11.48,25.6,25.6S218.93,460.8,204.8,460.8z M275.48,405.2
                                                c-11.7-27.48-39-46.8-70.68-46.8c-9.9,0-19.28,2.02-27.95,5.45L134,306.75c12.02-13.6,19.6-31.23,19.6-50.75
                                                c0-13.73-3.9-26.43-10.23-37.55l49.52-66.05c3.9,0.62,7.83,1.2,11.9,1.2c21.1,0,40.25-8.58,54.15-22.43l100.22,40.1
                                                c-0.25,2.62-0.77,5.23-0.77,7.93c0,33.32,21.48,61.48,51.2,72.07v60.65c-29.73,10.6-51.2,38.75-51.2,72.05l0.45,4.52L275.48,405.2z
                                                    M435.2,409.6c-14.15,0-25.6-11.48-25.6-25.6s11.45-25.6,25.6-25.6c14.12,0,25.6,11.48,25.6,25.6S449.33,409.6,435.2,409.6z"/>
                                </svg>
                                <span>{res.AREAS}</span>
                            </Button>
                        </Menu.Item>
                        <Menu.Item key="0.4">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/estimativa', hide, link) }} disabled={!profile.includes(4)}>
                                <MaterialIcon icon="flight_takeoff" className="iconS icon-pos iconMenu" />
                                <span>{res.PLANEJAMENTO}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.5">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/avaliacao', hide, link) }} disabled={!profile.includes(10)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="0 -100 800 800">
                                    <path d="m356.21 36.715h-0.023438c-32.711 0-64.109 5.6211-93.293 15.93l20.793 100.73c17.465-4.8477 35.82-7.3867 54.75-7.3867l0.75391 0.011719c9.9297-0.011719 19.699 0.73047 29.266 2.1406l36.332-107.25c-15.738-2.7617-31.93-4.1758-48.453-4.1758zm-112.84 23.672h-0.003906c-36.398 16.031-68.742 39.578-95.07 68.676l50.934 71.121c18.836-17.145 40.672-30.855 64.582-40.203zm145.56 91.859h0.003906c27.145 6.8711 52.227 19.188 74.094 35.762l0.003906 0.003907c6.0586 4.5938 11.875 9.5156 17.414 14.738l104.43-48.102c-4.0703-5.7812-8.3867-11.383-12.902-16.812l-0.007813-0.003907c-37.34-44.875-88.414-77.879-146.76-92.609zm-254.34-6.793-0.003906 0.003906c-20.887 26.906-36.977 57.75-46.984 91.219l59.719 35.336c9.3906-21.02 21.957-40.211 37.059-56.93zm221.34 153.61h0.003906c9.6445 0 17.461 7.8164 17.461 17.461 0 9.6484-7.8203 17.48-17.469 17.48h-0.007813c-9.6484-0.007812-17.469-7.8281-17.469-17.477s7.8203-17.465 17.469-17.465zm-273.69-41.48-0.003907 0.011718c-4.1602 19.145-6.3516 39.094-6.3516 59.551 0 7.2031 0.27344 14.344 0.80469 21.41l52.059 7.8086c1.3516-19.066 5.0977-37.438 10.934-54.797zm531.25-101.49h-0.015625c-1.7812 0-3.4062 0.60156-5.1914 1.4219l-235.39 108.42c-5.332-1.7852-11.035-2.7539-16.969-2.7539h-0.050781c-29.441-0.007812-53.285 23.902-53.285 53.34 0 29.457 23.875 53.328 53.328 53.348h0.011719c25.906-0.015625 47.477-18.48 52.305-42.965 0-0.003906 0.007813-0.007812 0.007813-0.007812 1.8945-1.3633 210.42-151.41 210.42-151.41 4.3008-3.0977 6.6055-8.4414 4.332-13.375-1.2266-2.6641-3.4453-4.5586-6.0156-5.4492l-0.03125-0.007812c-1.0977-0.39062-2.2617-0.55859-3.4219-0.55859zm-534.38 203.81v0.007813c3.2773 21.371 8.9805 42.023 16.828 61.586l37.875-9.0391c-3.3359-14.598-5.25-29.688-5.582-45.191zm25.391 80.816s0.003907 0.007813 0.003907 0.007813c7.5625 15.375 16.496 29.965 26.641 43.605l21.938-19.594c-5.3672-10.371-9.9492-21.156-13.668-32.359zm39.613 59.789v0.007813c5.6875 6.5625 11.641 12.871 17.906 18.891l0.003906 0.007813c2.125 2.3086 5.1758 3.7695 8.5664 3.7695h0.003906c6.418-0.007812 11.621-5.2109 11.621-11.629v-0.007812c0-2.8281-1.0117-5.418-2.6875-7.4297l-0.097656-0.11328c-5.6133-6.7305-10.852-13.73-15.648-21.078z" />
                                </svg>
                                <span>{res.AVALIACAO}</span>
                            </Button>
                        </Menu.Item>
                        <Menu.Item key="0.7">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/qualidade', hide, link) }} disabled={!profile.includes(11)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.8rem" height="1.8rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="-20 -50 400 400">
                                    <g id="_2539151417168">
                                        <path className="fil0" d="M133 17.44c58.05,0 106.23,43.9 115.57,101.56l-27.61 0c-8.97,-41.97 -44.93,-73.35 -87.96,-73.35 -49.77,0 -90.11,41.99 -90.11,93.79 0,25.33 9.64,48.3 25.32,65.18l-19.24 19.88c-20.54,-21.98 -33.19,-51.98 -33.19,-85.06 0,-67.38 52.48,-122 117.22,-122z" />
                                        <path className="fil0" d="M57.61 154.63l-42.68 0c-1.63,0 -2.97,-1.33 -2.97,-2.96l0 -24.46c0,-1.63 1.34,-2.96 2.97,-2.96l42.68 0c1.64,0 2.97,1.33 2.97,2.96l0 24.46c0,1.63 -1.33,2.96 -2.97,2.96z" />
                                        <path className="fil0" d="M67.46 95.53l-32.35 -26.76c-1.42,-1.16 -1.62,-3.26 -0.45,-4.67l15.13 -18.3c1.17,-1.41 3.27,-1.61 4.68,-0.45l32.35 26.76c1.41,1.16 1.61,3.26 0.45,4.67l-15.13 18.3c-1.17,1.41 -3.28,1.61 -4.68,0.45z" />
                                        <path className="fil0" d="M146.59 16.83l0 41.44c0,1.98 -1.62,3.59 -3.59,3.59l-23.21 0c-1.98,0 -3.59,-1.61 -3.59,-3.59l0 -41.44c0,-1.98 1.61,-3.59 3.59,-3.59l23.21 0c1.97,0 3.59,1.61 3.59,3.59z" />
                                        <g>
                                            <path className="fil0" d="M119.46 126.91l46.07 -48.13c5.44,-5.69 14.54,-5.89 20.22,-0.44l0.01 0c5.69,5.45 5.88,14.54 0.44,20.23l-46.08 48.13c-5.44,5.69 -14.53,5.88 -20.22,0.44l-0.01 0c-5.68,-5.45 -5.88,-14.54 -0.43,-20.23z" />
                                            <path className="fil0" d="M130.02 114.41c12.39,0 22.42,10.03 22.42,22.42 0,12.39 -10.03,22.43 -22.42,22.43 -12.39,0 -22.42,-10.04 -22.42,-22.43 0,-12.39 10.03,-22.42 22.42,-22.42z" />
                                        </g>
                                        <path className="fil0" d="M219.66 183.43l-19.48 -17.87 -42.87 42.86c-5.16,4.94 -9.72,4.52 -13.8,0l-25.63 -25.63c-6.35,-6.83 -12.86,-7.46 -19.58,0l-53.12 53.12c-5.03,8.19 12.45,23.9 20.39,15.83l35.82 -35.81c4.6,-4.75 9.19,-4.55 13.81,0l26.08 26.08c6.42,6.89 13.02,6.35 19.79,0l58.59 -58.58zm-8.47 -28.53l-21.82 -22.91 61.56 -0.4 0 62.24 -19.33 -21.41 -11.94 11.01 -19.48 -17.87 11.01 -10.66z" />
                                    </g>
                                </svg>
                                <span>{res.QUALIDADE}</span>
                            </Button>
                        </Menu.Item>
                        {false &&//profile.includes(5) &&
                            <Menu.Item key="0.8">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/trabalho/list', hide, link) }}>
                                    <MaterialIcon icon="timeline" className="iconS icon-pos iconMenu" />
                                    <span>{res.TRABALHO}</span>
                                </Button>
                            </Menu.Item>
                        }
                        {false &&// profile.includes(6) &&
                            <Menu.Item key="0.9">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/monitoramento', hide, link) }}>
                                    <MaterialIcon icon="cast" className="iconS icon-pos iconMenu" />
                                    <span>{res.MONITORAMENTO}</span>
                                </Button>
                            </Menu.Item>
                        }

                        <Menu.Item key="0.165">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/relatorio', hide, link) }} disabled={!profile.includes(9)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" fill="currentColor" className="bi bi-file-earmark-arrow-down-fill" viewBox="-4 -8 32 32">
                                    <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
                                    <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                                </svg>
                                <span>{res.RELATORIO}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.10">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/location', hide, link) }} disabled={!profile.includes(6)}>
                                <MaterialIcon icon="place" className="iconS icon-pos iconMenu" />
                                <span>{res.LOCALIZACAO}</span>
                            </Button>
                        </Menu.Item>
                        <Menu.Item key="0.11">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/monitoramento', hide, link) }} disabled={true}>
                                <MaterialIcon icon="cast" className="iconS icon-pos iconMenu" />
                                <span>{res.MONITORAMENTO}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.12">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/clima', hide, link) }} disabled={!profile.includes(6)}>
                                <MaterialIcon icon="cloud" className="iconS icon-pos iconMenu" />
                                <span>{res.CLIMA}</span>
                            </Button>
                        </Menu.Item>
                        {!profile.includes(13) && (
                            <Menu.Item key="0.13">
                                <Button className="nav-item" onClick={event => { this.handleClick('/app/relatorio-mapa/list', hide, link) }}>
                                    <MaterialIcon icon="fact_check" className="iconS icon-pos iconMenu" />
                                    <span>{res.RELATORIO_MAPA}</span>
                                </Button>
                            </Menu.Item>
                        )}
                        <Menu.Item key="0.14">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/diario-de-bordo/list', hide, link) }} disabled={true}>
                                <MaterialIcon icon="view_list" className="iconS icon-pos iconMenu" />
                                <span>{res.DIARIO_BORDO}</span>
                            </Button>
                        </Menu.Item>

                        <Menu.Item key="0.15">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/qualidade', hide, link) }} disabled={true}>
                                <MaterialIcon icon="attach_money" className="iconS icon-pos iconMenu" />
                                <span>{res.FINANCEIRO}</span>
                            </Button>
                        </Menu.Item>
                        <Menu.Item key="0.16">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/qualidade', hide, link) }} disabled={true}>
                                <MaterialIcon icon="inventory" className="iconS icon-pos iconMenu" />
                                <span>{res.ESTOQUE}</span>
                            </Button>
                        </Menu.Item>
                        <Menu.Item key="0.17">
                            <Button className="nav-item" onClick={event => { this.handleClick('/app/qualidade', hide, link) }} disabled={true}>
                                <MaterialIcon icon="handyman" className="iconS icon-pos iconMenu" />
                                <span>{res.MANUTENCAO}</span>
                            </Button>
                        </Menu.Item>
                        {profile.includes(7) &&
                            <SubMenu
                                className=".nav-menu"
                                key="0.19"
                                title={
                                    <Button className="nav-item">
                                        <MaterialIcon icon="web" className="iconS icon-pos iconMenu" />
                                        <span>{res.CADASTRO}</span>
                                    </Button>
                                }
                            >
                                {profile.includes(7) &&
                                    <Menu.Item key="1.1">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/cliente/list', hide, link) }}>
                                            <span>{res.CLIENTE}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(7) &&
                                    <Menu.Item key="1.2">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/aeronave/list', hide, link) }}>
                                            <span>{res.AERONAVE}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(7) &&
                                    <Menu.Item key="1.3">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/piloto/list', hide, link) }}>
                                            <span>{res.PILOTO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(7) &&
                                    <Menu.Item key="1.4">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/agronomo/list', hide, link) }}>
                                            <span>{res.AGRONOMO_}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(7) &&
                                    <Menu.Item key="1.5">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/tecnico/list', hide, link) }}>
                                            <span>{res.TECNICO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="1.6">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/dgps/list', hide, link) }}>
                                            <span>DGPS</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {false && profile.includes(2) &&
                                    <Menu.Item key="1.7">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/modulo/list', hide, link) }}>
                                            <span>{res.MODULO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {false &&//profile.includes(7) &&
                                    <Menu.Item key="1.8">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/piloto/list', hide, link) }}>
                                            <span>{res.PILOTO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                <Menu.Item key="1.11">
                                    <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/estacao-meteorologica/list', hide, link) }}>
                                        <span>{res.ESTACAO_METEOROLOGICA}</span>
                                    </Button>
                                </Menu.Item>
                                <Menu.Item key="1.9">
                                    <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/waypoint', hide, link) }}>
                                        <span>{res.WAYPOINT}</span>
                                    </Button>
                                </Menu.Item>
                                <Menu.Item key="1.10">
                                    <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/obstaculo', hide, link) }}>
                                        <span>{res.OBSTACULO}</span>
                                    </Button>
                                </Menu.Item>
                                <Menu.Item key="1.11">
                                    <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/perfil_auto', hide, link) }}>
                                        <span>{res.PERFIL_AUTOMACAO}</span>
                                    </Button>
                                </Menu.Item>
                            </SubMenu>
                        }
                        <SubMenu
                            key="0.22"
                            title={
                                <Button className="nav-item">
                                    <MaterialIcon icon="share" className="iconS icon-pos iconMenu" />
                                    <span>{res.COMPARTILHAMENTO}</span>
                                </Button>
                            }
                        >
                            <Menu.Item key="3.2">
                                <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/compartilhamento/cliente', hide, link) }}>
                                    <span>{res.CLIENTE}</span>
                                </Button>
                            </Menu.Item>
                            <Menu.Item key="3.2">
                                <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/compartilhamento/permissao', hide, link) }}>
                                    <span>{res.PERMISSAO_M}</span>
                                </Button>
                            </Menu.Item>
                        </SubMenu>
                        {profile.includes(2) &&
                            <SubMenu
                                className=".nav-menu"
                                key="0.20"
                                title={
                                    <Button className="nav-item">
                                        <MaterialIcon icon="lock" className="iconS icon-pos iconMenu" />
                                        <span>{res.ADMINISTRACAO}</span>
                                    </Button>
                                }
                            >
                                {profile.includes(2) &&
                                    <Menu.Item key="2.1">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/empresa/list', hide, link) }}>
                                            <span>{res.EMPRESA}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="2.2">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/usuario/list', hide, link) }}>
                                            <span>{res.USUARIO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="2.8">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/alerta', hide, link) }}>
                                            <span>{res.ALERTA}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="2.3">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/parceiro/list', hide, link) }}>
                                            <span>{res.PARCEIRO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="2.4">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/link', hide, link) }}>
                                            <span>{res.VINCULAR_PARCEIRO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="2.5">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/admin/saldo', hide, link) }}>
                                            <span>{res.SALDO}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(1) &&
                                    <Menu.Item key="2.6">
                                        <Button className="nav-item nav-item-sub" onClick={event => { this.handleClick('/app/cadastro/perfil/list', hide, link) }}>
                                            <span>{res.PERFIL}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(1) &&
                                    <Menu.Item key="2.7">
                                        <Button className="nav-item" onClick={event => { this.handleClick('/app/updategps', hide, link) }}>
                                            <span>{res.UPDATE_GPS}</span>
                                        </Button>
                                    </Menu.Item>
                                }
                                {profile.includes(2) &&
                                    <Menu.Item key="0.24">
                                        <Button className="nav-item" onClick={event => { this.handleClick('/app/teste-append-job', hide, link) }}>
                                            <span>Teste Append Job</span>
                                        </Button>
                                    </Menu.Item>
                                }
                            </SubMenu>
                        }
                        {profile.includes(1) &&
                            <React.Fragment>
                                <Menu.Item key="0.23">
                                    <Button className="nav-item" onClick={event => { this.handleClick('/app/teste-ai', hide, link) }}>
                                        <MaterialIcon icon="dashboard" className="iconS icon-pos iconMenu" />
                                        <span>Teste IA</span>
                                    </Button>
                                </Menu.Item>
                                <Menu.Item key="0.231">
                                    <Button className="nav-item" onClick={event => { this.handleClick('/app/teste-map', hide, link) }}>
                                        <MaterialIcon icon="map" className="iconS icon-pos iconMenu" />
                                        <span>Teste Map</span>
                                    </Button>
                                </Menu.Item>
                            </React.Fragment>
                            /* <Menu.Item key="0.23">
                                     <Button className="nav-item" onClick={event => { this.handleClick('/app/teste', hide, link) }}>
                                         <MaterialIcon icon="dashboard" className="iconS icon-pos iconMenu" />
                                         <span>Teste</span>
                                     </Button>
                                 </Menu.Item> */
                        }
                    </Menu>
                }
            </div >
        )
    }
}

export default SidMenu;
